import withTranslation from '../../../../globals/components/withTranslation'
import Component from './component'
import { ICompanyLogsProps } from '../types'

export default withTranslation(Component) as React.ComponentClass<ICompanyLogsProps>
